var map = {
	"./auth-background.webp": 1907,
	"./close-btn.webp": 1908,
	"./icon-caution.webp": 1909,
	"./icon-checked.webp": 1910,
	"./icon-contact-us.webp": 1911,
	"./icon-email.webp": 1912,
	"./icon-eye-close.webp": 1913,
	"./icon-eye-open.webp": 1914,
	"./icon-forget-phone.webp": 1915,
	"./icon-forget-whatsapp.webp": 1916,
	"./icon-google.webp": 1917,
	"./icon-login-email-2.webp": 1918,
	"./icon-login-email.webp": 1919,
	"./icon-password.webp": 1920,
	"./icon-robot-select.webp": 1921,
	"./icon-robot-unselect.webp": 1922,
	"./icon-telegram.webp": 1923,
	"./icon-user.webp": 1924,
	"./jackpot-cn.webp": 1925,
	"./jackpot-mobile-cn.webp": 1926,
	"./jackpot-mobile-ms.webp": 1927,
	"./jackpot-mobile.webp": 1928,
	"./jackpot-ms.webp": 1929,
	"./jackpot.webp": 1930,
	"./login-bg.webp": 1931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;